<template>
  <div class="col-md-10 ml-sm-auto pt-3 px-4 products">
    <CartNav v-if="cartStore.cart.length > 0" />
    <div class="row">
      <div class="col-md-12 text-start">
        <h5 class="bold d-inline-block">Products</h5>
        <span v-if="!isLoading && productsStore.products" class="small"
          >&nbsp;({{ productsStore.products.length }})</span
        >
        <span v-if="isLoading" class="small">&nbsp;Loading...</span>
      </div>
    </div>

    <Loading :isLoading="isLoading" />

    <div class="row">
      <div class="col-md-12">
        <div class="text-start mt-3" v-if="!productsStore.products">
          <span style="font-weight: bold"
            >Notice: Temporary Product Loading Issues</span
          ><br /><br />
          We are currently experiencing some issues with loading products. To
          resolve this, please try the following steps:<br /><br />
          Log out of your account and then log back in. <br /><br />
          <span class="ms-3"
            >1. Refresh your webbrowser after each step in the process.</span
          ><br />
          <span class="ms-3"
            >2. These actions often helprestore visibility of the
            products.</span
          ><br /><br />If the issue persists after trying these steps, please
          contact your Supply account manager at BioGaia for further assistance.
          Thank you for your understanding and cooperation.
        </div>
      </div>
      <element
        v-if="
          productsStore.hasAnyProducts() || productsStore.hasAnyFaultyProducts()
        "
      >
        <div v-if="productsStore.hasAnyFaultyProducts()">
          <FaultyProductItem :productData="productsStore.faultyProducts" />
        </div>
        <div v-for="(product, index) in productsStore.products" :key="index">
          <ProductItem :productData="product" />
        </div>
      </element>
      <element v-else>
        {{ isLoading ? "" : mainError }}
      </element>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import ProductItem from "@/components/products/ProductItem.vue";
import Loading from "@/components/shared/Loading.vue";
import CartNav from "@/components/shared/CartNav.vue";
import { useCartStore } from "@/store/cartStore";
import { useUserStore } from "@/store/userStore";
import { useProductsStore } from "@/store/productsStore";
import {
  ProductClient,
  ProductInformation,
  ProductInformationRequest,
} from "@/data/client";
import axios, { Axios } from "axios";
import { msalInstance } from "@/config/msalConfig";
import { msalService } from "@/config/useAuth";
import FaultyProductItem from "@/components/products/FaultyProductItem.vue";

@Component({
  components: { CartNav, ProductItem, FaultyProductItem, Loading },
})
class ProductsView extends Vue {
  cartStore = useCartStore();
  userStore = useUserStore();
  productsStore = useProductsStore();
  productClient!: ProductClient;
  isLoading = false;
  mainError = "";

  async mounted() {
    var axiosClient = axios.create();
    await this.initialize(axiosClient);

    this.productClient = new ProductClient(
      process.env.VUE_APP_BACKEND_URI ?? "",
      axiosClient
    );
    await this.getProductsAsync();
  }

  async initialize(axiosClient: Axios) {
    try {
      await msalInstance.initialize();
      this.registerAuthorizationHeaderInterceptor(axiosClient);
    } catch (error) {
      console.log("Initialization error", error);
    }
  }

  registerAuthorizationHeaderInterceptor =
    msalService().registerAuthorizationHeaderInterceptor;

  async getProductsAsync() {
    if (!this.productsStore.hasAnyProducts()) {
      this.isLoading = true;
      const req = new ProductInformationRequest({
        customerAccountNumber:
          this.userStore.userInfo?.customerAccountNumber?.toString(),
      });

      await this.productClient
        .getProducts(req)
        .then((results: ProductInformation[]) => {
          this.mainError = "";
          this.productsStore.setProducts(results);
          this.isLoading = false;
        })
        .catch((error: Error) => {
          this.productsStore.setProducts([]);
          this.isLoading = false;
          this.mainError = error.message;
          console.error("Error fetching products:", error);
        });
      return;
    }
  }
}

export default ProductsView;
</script>
